"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Compass, Search, Heart, User } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";

const NAV = [
  { href: "/explore", icon: Compass, key: "explore" as const },
  { href: "/search", icon: Search, key: "search" as const },
  { href: "/account/saved", icon: Heart, key: "saved" as const },
  { href: "/account", icon: User, key: "account" as const },
];

export function MobileBottomNav() {
  const pathname = usePathname() ?? "";
  const { t } = useLanguage();
  const labels: Record<string, string> = {
    explore: t.product?.explore ?? "Explore",
    search: t.product?.search ?? "Search",
    saved: t.product?.saved ?? "Saved",
    account: t.product?.account ?? "Account",
  };

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-gray-200 dark:border-gray-800 bg-white/95 dark:bg-gray-900/95 backdrop-blur pb-[env(safe-area-inset-bottom)]"
      aria-label="Main"
    >
      <ul className="flex items-stretch justify-around h-14">
        {NAV.map(({ href, icon: Icon, key }) => {
          const active =
            href === "/account"
              ? pathname === "/account" ||
                (pathname.startsWith("/account/") && !pathname.startsWith("/account/saved"))
              : href === "/account/saved"
                ? pathname.startsWith("/account/saved")
                : pathname === href || pathname.startsWith(`${href}/`);
          return (
            <li key={href} className="flex-1">
              <Link
                href={href}
                className={`flex flex-col items-center justify-center h-full gap-0.5 text-[10px] font-medium transition-colors ${
                  active ? "text-accentDark dark:text-accent" : "text-gray-500 dark:text-gray-400"
                }`}
              >
                <Icon className="w-5 h-5" strokeWidth={active ? 2.5 : 2} />
                <span>{labels[key]}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
